import sensecommon from "@sensechat/user-inteceptor";
import { axiosSenseChatCryptoInterceptors } from "@sensechat/crypto-interceptor/axios";
import { v4 as uuidv4 } from "uuid";
import Axios, {
  AxiosResponse,
  AxiosRequestConfig,
  InternalAxiosRequestConfig,
  AxiosError,
} from "axios";
import { HTTP_STATUS, PATH_PREFIX } from "../constants/request";
// import { authInvalid } from "./index";
import chalk from "./chalk";
import { META_DATA } from "../constants";

export const AuthPrefix = `${PATH_PREFIX}/auth/v1.0.3`;
export type ResponseData<T = any> = {
  code: number;
  description?: string;
  message: T;
  [key: string]: any;
};

type Reject = {
  code: number;
  description?: string;
  message?: any;
};
// 使用 @sensechat/crypto-inteceptor来代替

import { SenseChat } from "../utils/error";

const instance = Axios.create({
  baseURL: "",
  timeout: 30000,
  validateStatus: status => status < 500,
});

// const encryptAbled = /prod|stage|test|dev/.test(BUSINESS_ENV);

if (API_ENCRYPT) {
  /********************************** 加密操作 ******************************/
  const {
    requestFulfilled,
    requestRejected,
    responseFulfilled,
    responseRejected,
  } = axiosSenseChatCryptoInterceptors({
    excludeInterfaces: [
      { host: location.host, route: "/api/assistant/*", method: "*" },
      { host: location.host, route: "/api/buddy/*", method: "*" },
      { host: location.host, route: "/api/moe/*", method: "*" },
      { host: location.host, route: "/api/filechat/*", method: "*" },
      { host: location.host, route: "/api/global/*", method: "*" },
      { host: "www.googleapis.com", route: "*", method: "*" },
      { host: "identitytoolkit.googleapis.com", route: "*", method: "*" },
      { host: "securetoken.googleapis.com", route: "*", method: "*" },
      { host: "api-js.mixpanel.com", route: "*", method: "*" },
    ],
  });

  instance.interceptors.request.use(requestFulfilled, requestRejected);
  instance.interceptors.response.use(responseFulfilled, responseRejected);

  /********************************** 加密操作 ******************************/
}

const {
  http: {
    axiosinterceptors: { authInterceptor },
  },
} = sensecommon;

instance.interceptors.request.use(
  async (config: InternalAxiosRequestConfig) => {
    // 设置headers
    config.headers.set("content-type", "application/json;charset=UTF-8");
    config.headers.set("X-Request-Id", uuidv4());
    config.headers.set(
      "system-type",
      META_DATA.projectName === "mbs" ? "h5" : "web",
    );
    config.headers.set("version-code", "");

    if (OPEN_REQUEST_LOG) {
      config.headers.set("debug", "debug");
      chalk.request(config.url, JSON.stringify(config.data || config.params));
    }
    if (config.url && /\/auth\/.+\/(logout|logoff)/.test(config.url)) {
      config.data = { ...config.data };
    }
    if (config.url && /\/(assistant|buddy)\//.test(config.url)) {
      config.data = { ...config.data };
    }
    return config;
  },
  (err: AxiosError) => console.log("req error", JSON.stringify(err)),
);

instance.interceptors.request.use(authInterceptor.request);
instance.interceptors.response.use(authInterceptor.response(instance));

instance.interceptors.response.use(
  async (res: AxiosResponse<any, any>) => {
    if (OPEN_REQUEST_LOG) {
      console.log(chalk.response(res.config.url, JSON.stringify(res.data)));
    }
    if (res.status === HTTP_STATUS.SUCCESS) {
      // 定义好的错误码
      // 登录模块
      res.data.code = SenseChat.code2Status(res.data.code);
    } else if (META_DATA.projectName === "mbs") {
      const reject: Reject = {
        code: res.status,
        description: res.statusText,
        message: res.data?.message,
      };
      return Promise.reject(reject);
    }

    return Promise.resolve(res);
  },
  (err: AxiosError) => {
    console.log("res error", JSON.stringify(err));
    return Promise.reject(err);
  },
);

const Get = async (
  url: string,
  data: Record<string, any>,
  config?: AxiosRequestConfig,
): Promise<ResponseData> => {
  const resp = await instance.get(url, {
    params: data, // iOS13不允许在body中放置参数，需清空data
    withCredentials: true,
    ...config,
  });
  return resp.data;
};
const Post = async (
  url: string,
  data: Record<string, any>,
  config?: AxiosRequestConfig,
): Promise<ResponseData> => {
  const resp = await instance.post(url, data, config);
  return resp.data;
};
const Put = async (
  url: string,
  data: Record<string, any>,
  config?: AxiosRequestConfig,
): Promise<ResponseData> => {
  const resp = await instance.put(url, data, config);
  return resp.data;
};
// const Delete = async (url: string, data?: Record<string, any>): Promise<ResponseData> => {
//   const resp = await instance.delete(url, data);
//   return resp.data
// };

const Delete = async (
  url: string,
  data?: Record<string, any>,
): Promise<ResponseData> => {
  const resp = await instance.delete(url, data);
  return resp.data;
};

export default {
  // request: request,
  get: Get,
  post: Post,
  put: Put,
  delete: Delete,
};
